// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5q0DU","title":"Header_title__3p87J","left":"Header_left__1r58q","clinicName":"Header_clinicName__1hyqe"};